import {
    SearchedMergedInvoice,
    SearchedMergedInvoiceItem
} from "../../../../models/documents/invoices/merged-invoice/merged.invoice";
import {Amount} from "../../../../models/prices/price";

export interface TableLineData {
    invoice: SearchedMergedInvoice;
    item: SearchedMergedInvoiceItem;
    docNumber: string;
    salesDocNumber: string;
    date: string;
    price: Amount;
    qty: number;
    warehouse: string;
}

export const dataFactory = (invoices: SearchedMergedInvoice[]): TableLineData[] => {
    const lines: TableLineData[] = [];

    invoices.forEach(invoice => {
        let base: boolean = true;
        invoice.items.forEach(item => {
            lines.push({
                invoice: invoice,
                warehouse: invoice.warehouse,
                item: item,
                docNumber: base ? invoice.docNumber : '',
                salesDocNumber: item.salesDocNumber,
                date: item.date,
                price: item.price,
                qty: item.qty
            });
            base = false;
        })
    })

    return lines;
}